export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `42-44`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`],
  [`В груди, полуобхват`, `49`, `51`, `53`, `55`, `57`, `59`],
  [`Длина`, `68`, `70`, `72`, `74`, `76`, `78`]
];
